import React, { useRef } from 'react';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';
import { useApp } from '../context/AppContext';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

function RadarChart() {
  const { state } = useApp();
  const chartRef = useRef(null);

  const labels = [
    ['Planning Style', '(Open Problem)'], 
    ['Work Cadence', '(Deep Work)'], 
    ['Communication', '(Async/Artifact)'],
    ['Primary Focus', '(Strategy)'], 
    ['Initiation Driver', '(Internal)'], 
    ['Focus Depth', '(Needs Deep Focus)'],
    ['Pace Preference', '(Urgency-Driven)']
  ];

  const selectedProfile = state.userProfiles[state.selectedUser];
  const data = {
    labels: labels,
    datasets: [{
      label: '',
      data: selectedProfile ? selectedProfile.scores : [],
      fill: true,
      backgroundColor: 'rgba(54, 211, 153, 0.2)',
      borderColor: 'rgb(54, 211, 153)',
      pointBackgroundColor: 'rgb(54, 211, 153)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgb(54, 211, 153)'
    }]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        borderWidth: 3
      }
    },
    scales: {
      r: {
        angleLines: {
          color: 'rgba(255, 255, 255, 0.2)'
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.2)'
        },
        pointLabels: {
          color: 'rgb(209, 213, 219)',
          font: {
            size: 12,
            weight: '500'
          }
        },
        ticks: {
          color: 'rgb(156, 163, 175)',
          backdropColor: 'rgba(0,0,0,0.5)',
          stepSize: 2,
          font: {
            size: 10
          }
        },
        min: 0,
        max: 10
      }
    },
    plugins: {
      legend: {
        display: false
      }
    }
  };

  return (
    <div className="w-full h-[400px] md:h-[500px]">
      <h2 className="text-xl font-bold text-center mb-4 text-gray-300">
        Work Style Summary
      </h2>
      <div className="h-[calc(100%-3rem)]">
        <Radar ref={chartRef} data={data} options={options} />
      </div>
    </div>
  );
}

export default RadarChart;
